import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import rootReducer from './reducers';

const middleware =
  process.env.NODE_ENV !== 'production' ? [thunkMiddleware, loggerMiddleware] : [thunkMiddleware];
const middlewareEnhancer = applyMiddleware(...middleware);
const store = createStore(rootReducer, middlewareEnhancer);

export const testStore = createStore(rootReducer, applyMiddleware(thunkMiddleware));

export default store;
